import http from '@/utils/http' //引入axios
export const getLocationType = data => http.get('/rvm-center/api/locationtype', {
    params: data
}) //查找条码
export const updataLocationType = data => http.put('/rvm-center/api/locationtype', data) //編輯条码
export const addLocationType = data => http.post('/rvm-center/api/locationtype', data) //添加条码
export const deleteLocationType = data => http.delete('/rvm-center/api/locationtype', {
    params: data
}) //根据barcodes刪除条码
// export  const findBarcode = data=>http.get('/api/district/superior',{params:data}) //查找部门
export const getpercentage = data => http.get('/rvm-center/api/locationtype/percentage', {
    params: data
}) //查找条码
export default {
    getLocationType,
    updataLocationType,
    addLocationType,
    deleteLocationType,
    getpercentage
    // findBarcode
}